import { BottomSheet, Illustration } from "@clipboard-health/ui-components";
import { Text, Title, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface CreateShiftVerificationConfirmationBottomSheetProps {
  modalState: UseModalState;
  onContinue: () => void;
}

export function CreateShiftVerificationConfirmationBottomSheet(
  props: CreateShiftVerificationConfirmationBottomSheetProps
) {
  const { modalState, onContinue } = props;

  return (
    <BottomSheet
      modalState={modalState}
      canDismiss={false}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={() => {
              modalState.closeModal();
              onContinue();
            }}
          >
            Continue
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 9,
        }}
      >
        <Stack alignItems="center" spacing={8} sx={{ px: 2 }}>
          <Illustration type="request-sent" />
          <Title variant="h2" component="h3" sx={{ textAlign: "center" }}>
            Request sent
          </Title>
          <Text align="center">
            We sent your request to the workplace. You should hear back from them within 3 business
            days.
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
